import { render, staticRenderFns } from "./AutoLogout.vue?vue&type=template&id=23110a98&scoped=true"
import script from "./AutoLogout.vue?vue&type=script&lang=js"
export * from "./AutoLogout.vue?vue&type=script&lang=js"
import style0 from "./AutoLogout.vue?vue&type=style&index=0&id=23110a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23110a98",
  null
  
)

export default component.exports